var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParksOpenSpaces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 50,
    viewBox: "0 0 73 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7319 49.6422H2.10116C0.987113 49.6422 0.987113 47.958 2.10116 47.958H64.7319C65.846 47.958 65.846 49.6422 64.7319 49.6422Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1847 33.9329H21.6352C21.167 33.9329 20.7891 33.554 20.7891 33.0908V27.3479C20.7891 26.882 21.167 26.5059 21.6352 26.5059H45.1847C45.6529 26.5059 46.0308 26.8848 46.0308 27.3479V33.0908C46.0308 33.5568 45.6529 33.9329 45.1847 33.9329Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7528 43.9446H20.0727C19.6045 43.9446 19.2266 43.5657 19.2266 43.1026V37.3597C19.2266 36.8937 19.6045 36.5176 20.0727 36.5176H46.7528C47.221 36.5176 47.5989 36.8965 47.5989 37.3597V43.1026C47.5989 43.5685 47.221 43.9446 46.7528 43.9446Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8516 28.1895C22.1558 28.1895 22.7509 28.7705 22.7509 24.8437C22.7509 24.3778 23.1288 24.0016 23.597 24.0016C28.2928 24.0016 27.6978 23.4234 27.6978 27.3474C27.6978 27.8105 27.3198 28.1895 26.8516 28.1895Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8508 38.2013H23.5961C23.1279 38.2013 22.75 37.8223 22.75 37.3592V35.6133H27.6969V37.3592C27.6969 37.8223 27.3189 38.2013 26.8508 38.2013Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8508 49.6428H23.5961C23.1279 49.6428 22.75 49.2639 22.75 48.8007V45.6289H27.6969V48.8007C27.6969 49.2667 27.3189 49.6428 26.8508 49.6428Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2345 28.1895C38.5386 28.1895 39.1337 28.7705 39.1337 24.8437C39.1337 24.3778 39.5144 24.0016 39.9798 24.0016C44.6756 24.0016 44.0806 23.4234 44.0806 27.3474C44.0806 27.8105 43.6998 28.1895 43.2345 28.1895Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2414 38.2013H39.9867C39.5186 38.2013 39.1406 37.8223 39.1406 37.3592V35.6133H44.0875V37.3592C44.0875 37.8223 43.7068 38.2013 43.2414 38.2013Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2414 49.6428H39.9867C39.5186 49.6428 39.1406 49.2639 39.1406 48.8007V45.6289H44.0875V48.8007C44.0875 49.2667 43.7068 49.6428 43.2414 49.6428Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6242 37.3316C63.8446 37.3316 62.2032 36.6355 61.0018 35.4509V33.5507V33.4777V28.8211C61.8874 28.0885 63.1 26.7243 63.7149 26.1125C64.5017 25.3294 63.3059 24.1364 62.5191 24.9224L61.0018 26.4325V24.4677V24.3975V18.635C61.0018 17.5263 59.3095 17.5263 59.3095 18.635V22.4047L57.7922 20.8945C57.0053 20.1114 55.8067 21.3015 56.5964 22.0846C57.2084 22.6937 58.4268 24.0607 59.3123 24.7932V28.4113C59.3095 28.4422 59.3095 28.4703 59.3123 28.5011V31.4905L57.795 29.9804C57.0081 29.1973 55.8095 30.3874 56.5992 31.1705C57.2084 31.7796 58.4267 33.1465 59.3152 33.8791V35.7064C55.3385 39.2739 48.3754 36.6355 48.3754 30.7859C48.3754 29.3684 48.8295 28.0099 49.6699 26.8871C46.5591 23.2157 48.3529 17.5602 53.0007 16.3358C52.4367 12.3893 55.5165 8.8584 59.51 8.8584C63.0467 8.8584 65.9432 11.654 66.0814 15.1402C70.6362 16.3753 72.3792 21.8402 69.5025 25.4889C74.6044 29.1688 71.9984 37.3287 65.6301 37.3287L65.6242 37.3316Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1508 49.6423C59.6826 49.6423 59.3047 49.2633 59.3047 48.8002V37.8055C59.6459 37.595 59.9759 37.3536 60.289 37.0869C60.5174 37.2778 60.7515 37.4546 60.9969 37.6202V48.8003C60.9969 49.2635 60.6162 49.6423 60.1508 49.6423Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8383 49.6426C8.37013 49.6426 7.99219 49.2637 7.99219 48.8005V41.4072C8.58445 41.5139 9.09209 41.5111 9.68442 41.4072V48.8005C9.68442 49.2608 9.30649 49.6426 8.8383 49.6426Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02733 40.3965C-1.06556 39.1306 -4.32035 17.6044 8.41089 9.3302C8.69292 9.14775 9.05393 9.14775 9.33592 9.3302C22.0728 17.6159 18.8064 39.1311 9.71948 40.3965V34.328V34.2466V29.5928C10.6051 28.8602 11.8206 27.496 12.4326 26.8842C13.2195 26.1011 12.0237 24.9081 11.2368 25.6941L9.71948 27.2042V25.2478C9.7223 25.2197 9.7223 25.1888 9.71948 25.1608V19.4095C9.71948 18.3007 8.02725 18.3007 8.02725 19.4095V23.1791L6.50989 21.669C5.72306 20.8859 4.52439 22.076 5.31412 22.8591C5.92894 23.471 7.14453 24.8351 8.02725 25.5677V29.1942V29.2672V32.2622L6.50989 30.752C5.72306 29.9689 4.52439 31.159 5.31412 31.9421C5.92613 32.5512 7.14165 33.9182 8.02725 34.6507L8.02733 40.3965Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1223 11.067L43.9555 11.008L39.6404 10.9659C35.8386 10.7638 35.455 5.24553 39.2286 4.5606C39.5755 3.40134 40.5513 2.52003 41.7528 2.30388C42.661 -0.7444 46.9958 -0.76682 47.9576 2.23091C49.2154 2.5537 50.1602 3.58942 50.3633 4.8497C53.6179 6.1858 52.6647 11.0669 49.1252 11.0669L49.1223 11.067Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParksOpenSpaces);
export default __webpack_public_path__ + "static/media/Parks&OpenSpaces.c65f79c9f7ec0aec88b8340f840fbbac.svg";
export { ForwardRef as ReactComponent };